// src/pages/UniversalLedger/components/exportLedgerCsv.js
import dayjs from "dayjs";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatDate = (val) => {
  if (!val) return "";
  if (typeof val === "string" && /^\d{2}-\d{2}-\d{4}$/.test(val)) {
    const [day, month, year] = val.split("-");
    return dayjs(`${year}-${month}-${day}`).format("DD MMM YYYY");
  }
  const parsed = dayjs(val);
  return parsed.isValid() ? parsed.format("DD MMM YYYY") : String(val);
};

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

export const exportLedgerCsv = ({
  list,
  openingBalance,
  closingBalance,
  filename = "ledger",
  title = "Account Transaction Ledger",
}) => {
  const debitTotal  = list.reduce((s, r) => s + (Number(r.debit_amount)  || 0), 0);
  const creditTotal = list.reduce((s, r) => s + (Number(r.credit_amount) || 0), 0);

  const headers = ["No.", "Date", "Particular", "VCH No", "VCH Type", "Debit", "Credit", "Balance"];

  const rows = [
    [title],             // report title as first row
    [],                  // blank spacer
    headers.map(escape),
    ["", "Opening Balance", "", "", "", fmt(openingBalance), "", ""],
    ...list.map((r, i) => {
      const vchNo =
        r.vch_type === "Advance" && r.vch_no
          ? `ADV-${String(r.vch_no).slice(-6).toUpperCase()}`
          : r.vch_no || "";
      const particular = (r.particular || "").replace(/<[^>]*>/g, ""); // strip HTML
      return [i + 1, formatDate(r.created_date), particular, vchNo, r.vch_type || "",
              fmt(r.debit_amount), fmt(r.credit_amount), fmt(r.balance)].map(escape);
    }),
    ["", "Grand Total", "", "", "", fmt(debitTotal), fmt(creditTotal), ""],
    ["", "Closing Balance", "", "", "", fmt(closingBalance), "", ""],
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};